module.exports = __webpack_public_path__ + "img/22_76.43a982a2.png";